import React from 'react';
import { Link2, ArrowRight, Check, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const LinksToMessengersPage = () => {
  const { login } = useAuth();

  const features = [
    'Links personalizados',
    'WhatsApp, Instagram, Messenger',
    'Mensagem pré-definida',
    'Rastreamento de cliques',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Link2 className="h-4 w-4" />
                Links to Messengers
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Links</span> diretos para mensageiros
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Crie links curtos que direcionam clientes para WhatsApp, Instagram ou Messenger.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-gray-50 rounded-3xl p-8">
              <div className="bg-white rounded-xl p-4 shadow-sm mb-4">
                <p className="text-sm text-gray-500 mb-1">Seu link personalizado:</p>
                <div className="flex items-center gap-2">
                  <code className="bg-gray-100 px-3 py-2 rounded text-sm flex-1">chatalfa.link/sua-empresa</code>
                  <Button variant="outline" size="sm"><ExternalLink className="h-4 w-4" /></Button>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-green-100 rounded-xl p-4 text-center">
                  <p className="text-2xl mb-1">📱</p>
                  <p className="text-xs">WhatsApp</p>
                </div>
                <div className="bg-pink-100 rounded-xl p-4 text-center">
                  <p className="text-2xl mb-1">📸</p>
                  <p className="text-xs">Instagram</p>
                </div>
                <div className="bg-blue-100 rounded-xl p-4 text-center">
                  <p className="text-2xl mb-1">💬</p>
                  <p className="text-xs">Messenger</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Crie seus links agora</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LinksToMessengersPage;
